import { createPortal } from "react-dom";
import type { ResultItem } from "../../state.js";

interface LightboxProps {
  result: ResultItem | null;
  onClose: () => void;
  onDownload: (id: string) => void;
}

export function Lightbox({ result, onClose, onDownload }: LightboxProps) {
  if (!result) return null;

  return createPortal(
    <div className="lightbox-root open">
      <div className="lightbox-backdrop" onClick={onClose} />
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <img src={result.thumbUrl} alt={result.filename} />
        <div className="lightbox-toolbar">
          <span className="lightbox-filename">{result.filename}</span>
          <button
            className="lightbox-download"
            type="button"
            title="下載"
            onClick={() => onDownload(result.id)}
          >
            ⬇ 下載
          </button>
          <button
            className="lightbox-close"
            type="button"
            title="關閉 (Esc)"
            aria-label="關閉"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
